<template>
    <div class="container-fluid">
        <h4 class="bg-secondary text-white text-center p-2">Resolución Ejercicio Direccionamiento IP con Clases</h4>
        <div class="form-group">
            <label>Dirección IP:</label>
            <input class="form-control" type="text"
                v-model="ipgenerada" value="">
        </div>
        <class-addressing v-bind:ipaddress="ipgenerada" initial-value=""></class-addressing>
    </div>
</template>

<script>

import ClassAddressing from "./ClassAddressing";

export default {
    data: function () {
        return {
            ipgenerada: ''
        }
    },
    components: {ClassAddressing}
}
</script>